<!-- Inline Notes Display - Refactored to reduce duplication -->
<div class="inline-notes-container">

    <div *ngIf="loadingNotes" class="loading-indicator">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="inline-notes-grid lock-exempt" *ngIf="!loadingNotes">
        <!-- Iterate through note types -->
        <div *ngFor="let noteConfig of noteTypes" class="inline-note-card">
            <div class="inline-note-header">
                <span class="note-type-title">{{ noteConfig.titleKey | translate }} <span class="internal-description" *ngIf="noteConfig.type === 'INTERNAL'">{{'bikeshop.workshop.jobcard.manage.notes.internal_description' | translate}}</span></span>
                <hub-button [icon]="'plus-alt'" [size]="'sm'" [style]="'borderless'"
                    [text]="'bikeshop.workshop.jobcard.manage.notes.add_note' | translate"
                    [disabled]="noteConfig.newNote.isEditing || editingNote"
                    (buttonClick)="startAddingNote(noteConfig.type)" />
            </div>
            <div class="spacer" *ngIf="noteConfig?.notes?.notes?.length > 0"></div>

            <div class="inline-note-content">
                <!-- New note input -->
                <div class="inline-note-form" *ngIf="noteConfig.newNote.isEditing">
                    <textarea [id]="noteConfig.inputRef" #dynamicInput [(ngModel)]="noteConfig.newNote.note"
                        placeholder="{{ 'bikeshop.workshop.jobcard.manage.notes.add_note_placeholder' | translate }}"
                        class="inline-note-input" rows="2" (blur)="saveNewNoteBlur(noteConfig.type)"
                        (keydown)="onNoteKeyDown($event, 'new', noteConfig.type)"
                        [disabled]="updatingNote">
                    </textarea>
                    <div class="inline-note-actions">
                        <hub-button [text]="'general.cancel' | translate" [size]="'sm'" [style]="'outline'"
                            (buttonClick)="cancelAddingNote(noteConfig.type)" [disabled]="updatingNote">
                        </hub-button>
                        <hub-button [text]="'bikeshop.general.save' | translate" [size]="'sm'" [style]="'secondary'"
                            [loading]="updatingNote" (buttonClick)="saveNewNote(noteConfig.type)"
                            [disabled]="!noteConfig.newNote.note?.trim()">
                        </hub-button>
                    </div>
                    <div class="keyboard-shortcuts-hint">
                        <small>{{ 'bikeshop.workshop.jobcard.manage.notes.keyboard_shortcuts' | translate }}</small>
                    </div>
                </div>

                <!-- Existing notes -->
                <div *ngFor="let note of getLatestNotes(noteConfig.notes?.notes || [], noteConfig.showAll ? 999 : 2); let i = index"
                    class="inline-note-item">
                    <div class="note-meta">
                        <div>
                            <span class="note-date">{{ note.createdDate+'Z' | date: countryData.AngularDateFormat + '
                                h:mm a'
                                }}</span>
                            <!-- Display mode -->
                            <span class="note-text" *ngIf="!isEditing(note)">
                                <span [innerHTML]="note.note?.replaceAll('\n', '<br>')"></span>
                            </span>
                        </div>
                        <div class="note-actions">
                            <hub-button [icon]="'pencil'" [size]="'xs'" [style]="'borderless'"
                                (buttonClick)="startEditingNote(note)"
                                [disabled]="isEditing(note) || updatingNote">
                            </hub-button>
                            <hub-button [icon]="'trash'" [size]="'xs'" [style]="'borderless'"
                                (buttonClick)="deleteNote(note)" [disabled]="updatingNote">
                            </hub-button>
                        </div>
                    </div>

                    <!-- Display mode -->
                    <!-- <div class="note-text" *ngIf="!isEditing(note)">
                        <span>{{ note.note }}</span>
                    </div> -->

                    <!-- Edit mode -->
                    <div class="inline-note-form" *ngIf="isEditing(note)">
                        <textarea [(ngModel)]="editingNote.note" class="inline-note-input" rows="2"
                            (blur)="saveEditedNoteBlur()" (keydown)="onNoteKeyDown($event, 'edit')"
                            [disabled]="updatingNote">
                        </textarea>
                        <div class="inline-note-actions">
                            <hub-button [text]="'general.cancel' | translate" [size]="'sm'" [style]="'outline'"
                                (buttonClick)="cancelEditingNote()" [disabled]="updatingNote">
                            </hub-button>
                            <hub-button [text]="'bikeshop.general.save' | translate" [size]="'sm'" [style]="'secondary'"
                                [loading]="updatingNote" (buttonClick)="saveEditedNote()"
                                [disabled]="!editingNote?.note?.trim() || !hasNoteChanged()">
                            </hub-button>
                        </div>
                        <div class="keyboard-shortcuts-hint">
                            <small>{{ 'bikeshop.workshop.jobcard.manage.notes.keyboard_shortcuts' | translate }}</small>
                        </div>
                    </div>
                </div>

                <!-- View all/Show less links -->
                <div class="view-all-link" *ngIf="shouldShowViewAll(noteConfig.type)"
                    (click)="toggleShowAll(noteConfig.type)">
                    {{ 'bikeshop.general.see_all' | translate }} {{(noteConfig.notes.notes.length - 2 == 1 ? 'bikeshop.general.see_more_note' : 'bikeshop.general.see_more_notes') | translate :
                    {count : noteConfig.notes.notes.length - 2 } }}
                </div>
                <div class="view-all-link" *ngIf="shouldShowShowLess(noteConfig.type)"
                    (click)="toggleShowAll(noteConfig.type)">
                    {{ 'bikeshop.general.show_less' | translate }}
                </div>

                <!-- No notes message -->
                <!-- <div class="no-notes-preview"
                    *ngIf="!noteConfig.notes || !noteConfig.notes?.notes || noteConfig.notes?.notes?.length === 0">
                    <span>{{ 'bikeshop.modal.update_job_card.job_card.live_updates.notes_preview.no_notes' | translate
                        }}</span>
                </div> -->
            </div>
        </div>
    </div>

</div>
<p-confirmDialog></p-confirmDialog>
